<template>
  <div @click="foc">
    <div class="cTextArea">
      <textarea :placeholder="placeholder" v-model="currentValue" @focus="onFocus" @blur="onBlur" ref="textarea"> </textarea>
      <span class="tip" v-if="max">{{ currentLen }}/{{ max }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'max', 'placeholder', 'isFocus'],
  data() {
    return {
      currentValue: ''
    }
  },
  created() {
    this.currentValue = this.value
  },
  computed: {
    currentLen() {
      return this.value.length
    }
  },
  methods: {
    onFocus() {
      this.$emit('onFocus')
    },
    onBlur() {
      this.$emit('onBlur')
    },
    foc() {
      this.$refs.textarea.focus()
    }
  },
  watch: {
    isFocus() {
      if (this.isFocus) {
        this.$refs.textarea.focus()
      } else {
        this.$refs.textarea.blur()
      }
    },
    value(val) {
      this.currentValue = val
    },
    currentValue(newVal) {
      if (this.max && newVal && newVal.length > this.max) {
        this.currentValue = newVal.slice(0, this.max)
      }
      this.$emit('input', this.currentValue)
      this.$emit('on-change', this.currentValue)
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.cTextArea {
  width: 100%;
  margin-top: 1em;
  display: flex;
  position: relative;
  textarea {
    width: 100%;
    height: 10em;
    padding: 1em;
    border-radius: 1em;
    user-select: text;
  }
  .tip {
    position: absolute;
    bottom: 0.5em;
    right: 1em;
  }
}
</style>
